/**
 * configuration applied when BROCOLI_API_MODE = development
 */
module.exports = {}
